<div class="title-heading-bar" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutAlign.lt-md="center start" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px">
    <ng-content></ng-content>
</div>